import { z } from 'zod';

export const SummaryTone = z.enum(['baseline', 'shorter', 'more_punchy', 'more_technical']);
export type SummaryTone = z.infer<typeof SummaryTone>;

export const SummaryDraftRequest = z.object({ tone: SummaryTone.default('baseline') });
export type SummaryDraftRequest = z.infer<typeof SummaryDraftRequest>;

export const SummaryDraftResponse = z.union([
  z.object({ ok: z.literal(true), summary: z.string().min(1).max(2000) }),
  z.object({ ok: z.literal(false), reason: z.string() }),
]);
export type SummaryDraftResponse = z.infer<typeof SummaryDraftResponse>;

export const AnswerSuggestionQuestionKey = z.enum([
  'work_auth_us',
  'salary_expectation',
  'start_date',
  'relocation_willingness',
  'sponsorship_needed',
  'years_experience',
  'preferred_work_mode',
]);
export type AnswerSuggestionQuestionKey = z.infer<typeof AnswerSuggestionQuestionKey>;

export const AnswerSuggestRequest = z.object({ questionKey: AnswerSuggestionQuestionKey });
export type AnswerSuggestRequest = z.infer<typeof AnswerSuggestRequest>;

export const AnswerSuggestResponse = z.union([
  z.object({ ok: z.literal(true), answer: z.string().max(500) }),
  z.object({ ok: z.literal(false), reason: z.string() }),
]);
export type AnswerSuggestResponse = z.infer<typeof AnswerSuggestResponse>;
